export default __webpack_public_path__ + "static/media/olsonHome.7e65c461.webp";